// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"67937b29","199":"fb65d952","211":"abcc559d","340":"03858551","342":"6814df32","601":"239f195e","720":"8a10868a","897":"169cd612","940":"da5da2a0"}[chunkId] + ".chunk.js";
};